import { StoreZzim } from 'common/types/entities/store'
import { fetchStoreZzim, setStoreZzim } from 'common/services/channel'
import { StateKey } from 'common/utils/flipState'
import HttpStatus from 'common/utils/httpStatus'
import { getNaverLoginURL } from 'common/utils'

const initialState: StoreZzim = {
  zzimCount: 0,
  hasUserStoreZzim: false,
}

const FETCH = 'store/zzim/FETCH'
const SET = 'store/zzim/SET'

export const fetchZzim = (curState: StateKey, storeId: string, headers?: any) => async dispatch => {
  const result = await fetchStoreZzim(storeId, headers)
  dispatch({
    curState,
    storeId,
    ...result,
    params: { storeId },
    type: FETCH,
  })
}

export const setZzim = (curState: StateKey, storeId: string, hasUserStoreZzim: boolean) => async dispatch => {
  try {
    const response = await setStoreZzim(storeId, hasUserStoreZzim)
    dispatch({
      curState,
      storeId,
      zzimCount: response.htReturnValue.nZzimCount,
      hasUserStoreZzim: !hasUserStoreZzim,
      type: SET,
    })
  } catch (error) {
    const errorStatus = error.status
    if (errorStatus === HttpStatus.UNAUTHORIZED) {
      if (confirm(error.detailMessage)) {
        window.location.href = getNaverLoginURL()
      }
      return
    }
    if (errorStatus === HttpStatus.OK) {
      alert(error.message)
      return
    }
    alert('일시적으로 찜 기능이 동작하지 않습니다. 잠시 후 다시 시도해주세요.')
  }
}

const zzimReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH:
      return {
        storeId: action.storeId,
        zzimCount: action.zzimCount,
        hasUserStoreZzim: action.hasUserStoreZzim,
        params: action.params,
      }
    case SET:
      return {
        ...state,
        storeId: action.storeId,
        zzimCount: action.zzimCount,
        hasUserStoreZzim: action.hasUserStoreZzim,
      }
    default:
      return state
  }
}

export default zzimReducer
